import React, { createContext, useContext, useEffect, useRef, useState } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const Ctx = createContext({});

export function ProductPriceProvider({ children }) {
  const [overrides, setOverrides] = useState({});
  const esRef = useRef(null);

  useEffect(() => {
    function connect() {
      if (esRef.current) esRef.current.close();
      const es = new EventSource(`${API_BASE}/product-updates`);
      esRef.current = es;

      es.onmessage = (e) => {
        if (!e.data || e.data === 'ping' || e.data === 'connected') return;
        try {
          const d = JSON.parse(e.data);
          if (d.id) {
            setOverrides(prev => ({ ...prev, [d.id]: d }));
          }
        } catch {}
      };

      es.onerror = () => {
        es.close();
        // Reconnect after 5 seconds
        setTimeout(connect, 5000);
      };
    }

    connect();
    return () => { if (esRef.current) esRef.current.close(); };
  }, []);

  return <Ctx.Provider value={overrides}>{children}</Ctx.Provider>;
}

export function useProductOverride(productId) {
  const overrides = useContext(Ctx);
  return overrides[productId] || null;
}
